import { gql } from "@apollo/client/core";

export const GET_INDESIGN_TEMPLATES = gql`
    query getInDesignTemplates($type: String!, $categoryId: Int!) {
        getInDesignTemplates(type: $type, categoryId: $categoryId)  {
            id
            name
            type
        }
    }
`;

export const OPEN_PAGE_TEMPLATE_IN_INDESIGN = gql`
    mutation openPageTemplateInInDesign($pageTemplateId: Int!) {
        openPageTemplateInInDesign(pageTemplateId: $pageTemplateId) {
            success
            message
        }
    }
`;

export const OPEN_PRODUCT_TEMPLATE_IN_INDESIGN = gql`
    mutation openProductTemplateInInDesign($productTemplateId: Int!) {
        openProductTemplateInInDesign(productTemplateId: $productTemplateId) {
            success
            message
        }
    }
`;